/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SourceDestinationWeights } from "./SourceDestinationWeights";
export const SourceDestinationWeightsResponse = core.serialization.object({
    data: SourceDestinationWeights,
});
